import { makeStyles } from '@material-ui/core';
import { createFactoryStyles } from '../../../ui/styles/helpers';
export const useStyles = makeStyles(({ factory: factoryTheme }) => {
    return createFactoryStyles({
        fields: {
            display: 'flex',
            alignItems: 'center',
        },
        inputKey: {
            width: 200,
            marginRight: factoryTheme.spacing(2),
        },
        inputValue: {
            width: '100%',
            marginLeft: factoryTheme.spacing(2),
        },
        addBtn: {
            marginLeft: factoryTheme.spacing(4),
        },
        error: {
            color: factoryTheme.palette.red[100],
            marginTop: factoryTheme.spacing(2),
            '&:empty': {
                display: 'none',
            },
        },
    });
});
